import Column from './Column.styles';

export default Column;
